import ResetPasswordForm from "@/components/ResetPasswordForm";
import Page from '@/pages/Page';

const ForgotPasswordPage = () => {
  return (
    <Page title="Change Password" contentClassName="ion-padding" backDefault="/account">
      <ResetPasswordForm/>
    </Page>
  );
}

export default ForgotPasswordPage;
